<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER QISMI -->
      <div class="header-row">
        <h2 class="page-title">{{ $t("Mijozlar Bazasi") }}</h2>
        <div class="header-actions">

          <!-- Qidiruv -->
          <div class="search-wrapper">
            <b-icon icon="search" class="search-icon"></b-icon>
            <input v-model="filter" type="search" :placeholder="$t('Qidiruv...')" class="modern-search">
          </div>

          <!-- Sotuv turi filter -->
          <div class="sale-type-filter">
            <button :class="['filter-btn', { active: saleTypeFilter === '' }]" @click="saleTypeFilter = ''">
              {{ $t("Barchasi") }}
            </button>
            <button :class="['filter-btn', { active: saleTypeFilter === 'chakana' }]" @click="saleTypeFilter = 'chakana'">
              {{ $t("Chakana") }}
            </button>
            <button :class="['filter-btn', { active: saleTypeFilter === 'optom' }]" @click="saleTypeFilter = 'optom'">
              {{ $t("Optom") }}
            </button>
          </div>

          <!-- Refresh tugmasi -->
          <button class="refresh-btn" @click="Data(parent)" title="Yangilash">
            <b-icon icon="arrow-repeat"></b-icon>
          </button>

          <!-- Excel yuklash -->
          <button class="refresh-btn" v-b-modal.modal-clients-upload v-if="rule.change" title="Excel yuklash">
            <b-icon icon="file-earmark-spreadsheet"></b-icon>
          </button>

          <!-- Qo'shish tugmasi (Gradient) -->
          <button class="add-btn" @click="$router.push('/malumot/kontragent/create')" v-if="rule.change">
            <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Qo'shish") }}
          </button>

          <top></top>
        </div>
      </div>

      <!-- BALANCE FILTER (qarzdor / haqdor / hammasi) -->
      <div class="balance-filter-row">
        <button :class="['bf-btn', { active: balanceFilter === '' }]" @click="setBalanceFilter('')">
          📋 Hammasi
        </button>
        <button :class="['bf-btn', { active: balanceFilter === 'qarzdor' }]" @click="setBalanceFilter('qarzdor')">
          🔴 Qarzdor
        </button>
        <button :class="['bf-btn', { active: balanceFilter === 'haqdor' }]" @click="setBalanceFilter('haqdor')">
          🟢 Haqdor
        </button>
        <button :class="['bf-btn', { active: balanceFilter === 'tenglashgan' }]" @click="setBalanceFilter('tenglashgan')">
          ⚪ Tenglik
        </button>

        <!-- Jami summary -->
        <div class="balance-summary" v-if="totals">
          <div class="bs-cell">
            <span class="bs-label">Jami so'm qarz:</span>
            <strong class="bs-positive">+{{ formatMoney(totals.qarzdor_total) }}</strong>
          </div>
          <div class="bs-cell" v-if="totals.haqdor_total > 0">
            <span class="bs-label">Biz qarzdor:</span>
            <strong class="bs-negative">−{{ formatMoney(totals.haqdor_total) }}</strong>
          </div>
          <div class="bs-cell" v-if="totals.qarzdor_total_dollar > 0">
            <span class="bs-label">Jami $ qarz:</span>
            <strong class="bs-positive">+{{ formatDollar(totals.qarzdor_total_dollar) }}</strong>
          </div>
          <div class="bs-cell" v-if="totals.haqdor_total_dollar > 0">
            <span class="bs-label">Biz $ qarzdor:</span>
            <strong class="bs-negative">−{{ formatDollar(totals.haqdor_total_dollar) }}</strong>
          </div>
        </div>
      </div>

      <!-- JADVAL QISMI -->
      <div class="table-card">
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width: 50px">#</th>
                <th>{{ $t('MIJOZ') }}</th>
                <th>{{ $t('TEL') }}</th>
                <th class="num">SO'M QARZI</th>
                <th class="num">DOLLAR QARZI</th>
                <th style="width: 110px; text-align: center;">HOLAT</th>
                <th style="width: 130px; text-align: center;">{{ $t('AMALLAR') }}</th>
              </tr>
            </thead>
            <tbody>
              <!-- Ma'lumotlar -->
              <tr v-for="(item, index) in filteredRows" :key="item.id" @dblclick="Selectkontragent(item)">
                <td><span class="id-badge">{{ index + 1 }}</span></td>
                <td>
                  <div class="font-bold">{{ item.name }}</div>
                  <div class="text-muted small" v-if="item.address">{{ item.address }}</div>
                </td>
                <td>{{ item.phone_number || '—' }}</td>

                <!-- SUM balansi -->
                <td class="num">
                  <span v-if="item.balance > 0" class="bal-badge bal-debt">
                    +{{ formatMoney(item.balance_abs) }}
                  </span>
                  <span v-else-if="item.balance < 0" class="bal-badge bal-credit">
                    −{{ formatMoney(item.balance_abs) }}
                  </span>
                  <span v-else class="text-muted">—</span>
                </td>

                <!-- DOLLAR balansi -->
                <td class="num">
                  <span v-if="item.balance_dollar > 0" class="bal-badge bal-debt">
                    +{{ formatDollar(item.balance_dollar_abs) }}
                  </span>
                  <span v-else-if="item.balance_dollar < 0" class="bal-badge bal-credit">
                    −{{ formatDollar(item.balance_dollar_abs) }}
                  </span>
                  <span v-else class="text-muted">—</span>
                </td>

                <td class="text-center">
                  <span :class="['status-pill', overallStatus(item)]">
                    {{ overallStatusLabel(item) }}
                  </span>
                </td>
                <td>
                  <div class="actions">
                    <button class="icon-btn pay" @click="openPayModal(item)" title="To'lov olish">
                      <b-icon icon="cash-stack"></b-icon>
                    </button>
                    <button class="icon-btn edit" @click="$router.push('/malumot/kontragent/update/' + item.id)">
                      <b-icon icon="pencil-square"></b-icon>
                    </button>
                    <button class="icon-btn del" @click="Trash(item.id)" v-if="rule.change">
                      <b-icon icon="trash"></b-icon>
                    </button>
                  </div>
                </td>
              </tr>

              <!-- Loading -->
              <tr v-if="loading">
                <td colspan="7" class="empty-row">
                  <div class="spinner"></div> Yuklanmoqda...
                </td>
              </tr>

              <!-- Bo'sh holat -->
              <tr v-if="!loading && filteredRows.length === 0">
                <td colspan="7" class="empty-row">{{ $t("Ma'lumot topilmadi") }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- FOOTER -->
        <div class="table-footer">
          <div class="info">
            Jami: <b>{{ filteredRows.length }}</b> / <b>{{ totalCount }}</b> ta mijoz
          </div>
          <div v-if="hasMore">
            <button class="btn-load-more" @click="loadMore">Yana 50 ta yuklash</button>
          </div>
        </div>
      </div>
    </div>

    <!-- TO'LOV MODAL -->
    <b-modal id="modal-pay" hide-footer size="md" modal-class="modern-modal">
      <template #modal-title>
        <span v-if="payTarget">
          <b-icon icon="cash-stack"></b-icon>
          {{ payTarget.name }} — to'lov olish
        </span>
      </template>

      <div v-if="payTarget" class="pay-content">
        <!-- KASSA BALANSI (yuqorida — joriy holat) -->
        <div v-if="kassaBalance" class="kassa-row">
          <div class="kr-title">💼 KASSA hozir:</div>
          <div class="kr-cells">
            <div v-if="kassaBalance.sum_total !== 0" class="kr-cell">
              <span class="kr-label">So'm</span>
              <strong>{{ formatMoney(kassaBalance.sum_total) }}</strong>
            </div>
            <div v-if="kassaBalance.dollar_total !== 0" class="kr-cell dollar">
              <span class="kr-label">USD</span>
              <strong>{{ formatDollar(kassaBalance.dollar_total) }}</strong>
            </div>
          </div>
        </div>

        <!-- Joriy balans -->
        <div class="pay-balance-row">
          <div class="pb-cell" v-if="payTarget.balance !== 0">
            <span class="pb-label">SO'M qarzi:</span>
            <strong :class="payTarget.balance > 0 ? 'positive' : 'negative'">
              {{ payTarget.balance > 0 ? '+' : '−' }}{{ formatMoney(payTarget.balance_abs) }}
            </strong>
          </div>
          <div class="pb-cell" v-if="payTarget.balance_dollar !== 0">
            <span class="pb-label">DOLLAR qarzi:</span>
            <strong :class="payTarget.balance_dollar > 0 ? 'positive' : 'negative'">
              {{ payTarget.balance_dollar > 0 ? '+' : '−' }}{{ formatDollar(payTarget.balance_dollar_abs) }}
            </strong>
          </div>
        </div>

        <!-- Pay type selector — DB'dagi pay_type jadvalidan -->
        <div class="form-unit">
          <label>To'lov turi</label>
          <div class="paytype-grid">
            <label
              v-for="pt in payTypes"
              :key="pt.id"
              class="pt-option"
              :class="{
                active: payForm.pay_type_id === pt.id,
                'dollar-opt': pt.id === dollarPayTypeId,
              }"
            >
              <input type="radio" :value="pt.id" v-model="payForm.pay_type_id" />
              {{ payTypeIcon(pt.id, pt.name) }} {{ pt.name }}
              <small>{{ pt.id === dollarPayTypeId ? '(USD)' : "(so'm)" }}</small>
            </label>
          </div>
        </div>

        <!-- Sum input -->
        <div class="form-unit">
          <label>{{ isDollarSelected ? 'Summa (USD)' : "Summa (so'm)" }}</label>
          <input
            type="number"
            v-model.number="payForm.summa"
            min="0"
            :step="isDollarSelected ? 1 : 1000"
            class="form-input"
            :placeholder="isDollarSelected ? '0 USD' : '0 so\'m'"
          />
        </div>

        <!-- KONVERTATSIYA toggle (faqat dollar tanlanganda VA mijozda so'm qarzi bo'lganda) -->
        <div v-if="isDollarSelected && payTarget.balance > 0" class="convert-block">
          <label class="conv-toggle">
            <input type="checkbox" v-model="payForm.convert_to_sum" />
            <span class="conv-text">
              💱 <strong>Konvertatsiya $→so'm</strong> — Dollar to'lov so'm qarzini kamaytirsin
            </span>
          </label>
          <div v-if="payForm.convert_to_sum && payForm.summa > 0" class="conv-info">
            <div>Kursi: <b>{{ formatMoney(currentRate) }}</b></div>
            <div>{{ payForm.summa }} $ × {{ formatMoney(currentRate) }} = <b class="positive">{{ formatMoney(payForm.summa * currentRate) }}</b> so'm qarz kamayadi</div>
            <div class="conv-cassa">📥 Kassaga: <b>{{ payForm.summa }} $</b> tushadi</div>
          </div>
        </div>

        <!-- KONVERTATSIYA toggle (so'm tanlanganda VA mijozda dollar qarzi bo'lganda) -->
        <div v-if="!isDollarSelected && payTarget.balance_dollar > 0" class="convert-block">
          <label class="conv-toggle">
            <input type="checkbox" v-model="payForm.convert_to_dollar" />
            <span class="conv-text">
              💱 <strong>Konvertatsiya so'm→$</strong> — So'm to'lov dollar qarzini kamaytirsin
            </span>
          </label>
          <div v-if="payForm.convert_to_dollar && payForm.summa > 0 && currentRate > 0" class="conv-info">
            <div>Kursi: <b>{{ formatMoney(currentRate) }}</b></div>
            <div>{{ formatMoney(payForm.summa) }} so'm ÷ {{ formatMoney(currentRate) }} = <b class="positive">{{ (payForm.summa / currentRate).toFixed(2) }} $</b> dollar qarz kamayadi</div>
            <div class="conv-cassa">📥 Kassaga: <b>{{ formatMoney(payForm.summa) }} so'm</b> tushadi</div>
          </div>
        </div>

        <!-- Hint -->
        <div class="hint" v-if="isDollarSelected && !payForm.convert_to_sum">
          ⚠️ Bu DOLLAR qarzini kamaytiradi (kassaga ham dollar tushadi)
        </div>
        <div class="hint" v-else-if="isDollarSelected && payForm.convert_to_sum">
          ✅ SO'M qarzini kamaytiradi (kassaga DOLLAR tushadi — alohida)
        </div>
        <div class="hint" v-else-if="!isDollarSelected && payForm.convert_to_dollar">
          ✅ DOLLAR qarzini kamaytiradi (kassaga SO'M tushadi — alohida)
        </div>
        <div class="hint" v-else>
          ✅ Bu SO'M qarzini kamaytiradi
        </div>

        <div class="form-unit">
          <label>Izoh (ixtiyoriy)</label>
          <input type="text" v-model="payForm.comment" class="form-input" placeholder="Izoh..." />
        </div>

        <!-- QARZ QO'SHISH BLOKI -->
        <div class="add-debt-block">
          <label class="ad-toggle">
            <input type="checkbox" v-model="payForm.add_debt_only" />
            <span>📝 <strong>Qarz yozish</strong> — mijozning qarzini oshirish</span>
          </label>

          <div v-if="payForm.add_debt_only" class="ad-fields">
            <!-- Qarz turi: kassasiz yoki kassadan pul berib -->
            <div class="debt-mode">
              <label :class="['dm-opt', payForm.debt_mode === 'kassasiz' ? 'active' : '']">
                <input type="radio" value="kassasiz" v-model="payForm.debt_mode" />
                <span>📒 Kassasiz qarz<small>eski / oddiy qarz — kassaga tegmaydi</small></span>
              </label>
              <label :class="['dm-opt', payForm.debt_mode === 'kassadan' ? 'active' : '']">
                <input type="radio" value="kassadan" v-model="payForm.debt_mode" />
                <span>💸 Kassadan pul berib<small>naqd berib qarz — kassadan chiqim</small></span>
              </label>
            </div>

            <div class="form-unit">
              <label>{{ isDollarSelected ? 'Qarz summasi (USD)' : "Qarz summasi (so'm)" }}</label>
              <input
                type="number"
                v-model.number="payForm.qarz_summa"
                min="0"
                :step="isDollarSelected ? 1 : 1000"
                class="form-input"
                :placeholder="isDollarSelected ? '0 USD' : '0 so\'m'"
              />
            </div>
            <div class="form-unit">
              <label>Qarz izohi</label>
              <input type="text" v-model="payForm.qarz_comment" class="form-input" placeholder="Masalan: avans bermadi, kreditga oldi..." />
            </div>

            <div v-if="payForm.debt_mode === 'kassadan'" class="hint warn">
              💸 Kassadan <b>{{ isDollarSelected ? formatDollar(payForm.qarz_summa) + ' $' : formatMoney(payForm.qarz_summa) + " so'm" }}</b> chiqadi (mijozga berildi) va qarzi shuncha oshadi
            </div>
            <div v-else class="hint">
              💡 Bu summa <b>kassaga ta'sir qilmaydi</b> — faqat mijozning qarzini oshiradi (revizyaga o'xshash)
            </div>
          </div>
        </div>

        <div class="modal-actions">
          <button class="btn-cancel" @click="$bvModal.hide('modal-pay')">Bekor</button>
          <button class="btn-save" @click="submitPay" :disabled="paying || !canSubmit">
            <b-icon icon="check-all"></b-icon>
            {{ paying ? 'Saqlanmoqda...' : saveButtonLabel }}
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Clients Excel yuklash modal -->
    <b-modal id="modal-clients-upload" title="📥 Excel orqali mijozlarni yuklash" hide-footer centered size="lg" modal-class="z-top-modal">
      <div class="alert alert-info small mb-3">
        <div><b>Kerakli ustunlar:</b> ФИО, Телефон, Дата регистрации, Текущий долг (Адрес — ixtiyoriy)</div>
        <ul class="mb-0 mt-2 ps-3">
          <li>Telefon takrorlansa qarz qo'shiladi (dedup)</li>
          <li><b>Qarz &gt; 0</b> → mijoz Nasiyalar ro'yxatida ko'rinadi</li>
          <li>Barcha qatorlar <b>mijoz</b> sifatida yuklanadi (usta ajratilmaydi)</li>
          <li>Yuklash 100 ta'lab chunklarda — 1000+ mijoz xavfsiz</li>
        </ul>
      </div>
      <input type="file" accept=".xlsx,.xls" @change="onClientsFile" class="form-control mb-3">
      <button class="btn btn-success" :disabled="clientsLoading || !clientsFile" @click="uploadClients">
        <span v-if="clientsLoading"><span class="spinner-border spinner-border-sm"></span> Yuklanmoqda... (sabr qiling)</span>
        <span v-else>📤 Yuklash</span>
      </button>
      <div v-if="clientsResult" class="mt-3 alert alert-success small">
        <div class="fw-bold mb-2">✅ Yuklash tugadi</div>
        <table class="table table-sm table-borderless mb-0 small">
          <tr><td>Jami Excel qatorlari:</td><td><b>{{ clientsResult.total_rows }}</b></td></tr>
          <tr><td>Unikal yozuvlar:</td><td><b>{{ clientsResult.unique_clients }}</b></td></tr>
          <tr v-if="clientsResult.failed_rows > 0" class="text-danger">
            <td>Xato bo'lgan qatorlar:</td><td><b>{{ clientsResult.failed_rows }}</b></td>
          </tr>
          <tr class="border-top">
            <td colspan="2"><b>👥 MIJOZLAR (Kontragent)</b></td>
          </tr>
          <tr><td>Yangi yaratildi:</td><td>{{ clientsResult.created }}</td></tr>
          <tr><td>Mavjudi yangilandi:</td><td>{{ clientsResult.updated }}</td></tr>
          <tr><td>Qarzdorlar:</td><td><b class="text-danger">{{ clientsResult.with_debt }}</b></td></tr>
          <tr><td>Jami qarz:</td><td><b class="text-danger">{{ Number(clientsResult.total_debt).toLocaleString('ru-RU') }} so'm</b></td></tr>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<style>
.z-top-modal { z-index: 9999 !important; }
.modal-backdrop.show { z-index: 9990 !important; }
</style>

<script>
import Top from "../../Layout/Top.vue";

export default {
  components: { Top },
  data() {
    return {
      filter: "",
      saleTypeFilter: "",
      balanceFilter: "qarzdor",  // default: qarzdorlarni ko'rsatish
      parent: 0,
      list: [],
      totals: null,
      totalCount: 0,
      page: 1,
      limit: 50,
      hasMore: false,
      loading: false,
      rule: { change: true },
      clientsFile: null,
      clientsLoading: false,
      clientsResult: null,
      // To'lov modal
      payTarget: null,
      paying: false,
      payForm: {
        pay_type_id: null,
        summa: 0,
        comment: '',
        convert_to_sum: false,
        convert_to_dollar: false,
        add_debt_only: false,
        debt_mode: 'kassasiz',   // 'kassasiz' = oddiy/eski qarz | 'kassadan' = pul berib qarz
        qarz_summa: 0,
        qarz_comment: '',
      },
      payTypes: [],
      kassaBalance: null,           // { items, sum_total, dollar_total }
      currentRate: 12000,           // joriy dollar kursi (default fallback)
    };
  },
  computed: {
    filteredRows() {
      let rows = this.list;
      if (this.filter.length > 1) {
        const q = this.filter.toLowerCase();
        rows = rows.filter(row =>
          (row.name && row.name.toLowerCase().includes(q)) ||
          (row.phone_number && row.phone_number.includes(this.filter))
        );
      }
      return rows;
    },
    // Pay_types ichidan "Dollar" / "USD" / "$" bo'lgan turini topib id'sini olamiz.
    // Backend kontragent_register.price_type=3 deb dollar deb bilgan, lekin
    // ehtiyotkorlik uchun nomidan ham qidiramiz.
    dollarPayTypeId() {
      if (!this.payTypes.length) return 3; // fallback (3 = utils.js'dagi Dollar)
      const found = this.payTypes.find(p => {
        const n = String(p.name || '').toLowerCase();
        return n.includes('dollar') || n.includes('usd') || n.includes('$') || n === 'долл' || n.startsWith('доллар');
      });
      return found ? found.id : 3;
    },
    isDollarSelected() {
      return this.payForm.pay_type_id === this.dollarPayTypeId;
    },
    payTypeIcon() {
      // Pay type ID -> emoji
      return (id, name) => {
        const n = String(name || '').toLowerCase();
        if (id === this.dollarPayTypeId) return '💲';
        if (n.includes('plast') || n.includes('пласт') || n.includes('card')) return '💳';
        if (n.includes('shot')   || n.includes('шот')   || n.includes('перевод')) return '📲';
        if (n.includes('naqd')   || n.includes('нақд')  || n.includes('cash'))   return '💵';
        return '💰';
      };
    },
    // Saqlash mumkinmi? — to'lov yoki qarz qo'shish bo'lishi kerak
    canSubmit() {
      const hasPayment = Number(this.payForm.summa || 0) > 0;
      const hasDebtAdd = !!this.payForm.add_debt_only && Number(this.payForm.qarz_summa || 0) > 0;
      return hasPayment || hasDebtAdd;
    },
    // Tugma nomi kontekstga qarab
    saveButtonLabel() {
      const hasPayment = Number(this.payForm.summa || 0) > 0;
      const hasDebtAdd = !!this.payForm.add_debt_only && Number(this.payForm.qarz_summa || 0) > 0;
      if (hasPayment && hasDebtAdd) return "💾 To'lov + Qarz saqlash";
      if (hasDebtAdd && !hasPayment) return "📝 Qarzni saqlash";
      if (hasPayment) return "💵 To'lovni saqlash";
      return "Saqlash";
    },
  },
  watch: {
    filter() {
      // Qidiruvni server tomonida ham qilish (debounce)
      if (this._searchTimer) clearTimeout(this._searchTimer);
      this._searchTimer = setTimeout(() => {
        this.page = 1;
        this.loadBalances(false);
      }, 400);
    },
  },
  mounted() {
    this.fetchPayTypes();
    this.loadBalances(false);
    this.loadKassaBalance();
    this.loadDollarRate();
  },
  methods: {
    async fetchPayTypes() {
      try {
        const res = await axios.get('api/v1/pay-type/');
        // id bo'yicha tartiblab olamiz
        this.payTypes = (res.data || []).slice().sort((a, b) => a.id - b.id);
      } catch (e) {
        // Server javob bermasa fallback variantlar (utils.js bilan moslashgan)
        this.payTypes = [
          { id: 1, name: 'Naqd' },
          { id: 2, name: 'Plastik' },
          { id: 3, name: 'Dollar' },
          { id: 4, name: 'Shot' },
        ];
      }
    },
    formatMoney(n) {
      const v = parseFloat(n || 0);
      return v.toLocaleString('ru-RU', { maximumFractionDigits: 0 }) + " so'm";
    },
    formatDollar(n) {
      const v = parseFloat(n || 0);
      return v.toLocaleString('ru-RU', { maximumFractionDigits: 2 }) + " $";
    },
    overallStatus(item) {
      // SUM va DOLLAR ikkalasini birlashtirib umumiy status
      const sumDebt = (item.balance || 0) > 0;
      const dollarDebt = (item.balance_dollar || 0) > 0;
      const sumCredit = (item.balance || 0) < 0;
      const dollarCredit = (item.balance_dollar || 0) < 0;
      if (sumDebt || dollarDebt) return 'sb-debt';
      if (sumCredit || dollarCredit) return 'sb-credit';
      return 'sb-zero';
    },
    overallStatusLabel(item) {
      const c = this.overallStatus(item);
      return { 'sb-debt': '🔴 Qarzdor', 'sb-credit': '🟢 Haqdor', 'sb-zero': '⚪ Tenglik' }[c] || '';
    },

    setBalanceFilter(v) {
      this.balanceFilter = v;
      this.page = 1;
      this.loadBalances(false);
    },

    async loadBalances(append) {
      this.loading = true;
      try {
        const params = {
          type: 1,                       // mijozlar
          page:  this.page,
          limit: this.limit,
        };
        if (this.balanceFilter) params.status = this.balanceFilter;
        if (this.filter.length > 1) params.q = this.filter;

        const res = await axios.get('api/v1/kontragent/balances', { params });
        const data = res.data || {};
        const items = data.items || [];

        if (append) {
          this.list = this.list.concat(items);
        } else {
          this.list = items;
        }
        this.totalCount = (data.pagination && data.pagination.total) || items.length;
        this.hasMore = (this.list.length < this.totalCount);
        this.totals = (data.totals && data.totals.mijoz) || null;
      } catch (e) {
        console.error('Balanslarni yuklashda xato:', e);
      } finally {
        this.loading = false;
      }
    },

    async loadMore() {
      this.page++;
      await this.loadBalances(true);
    },

    onClientsFile(e) {
      this.clientsFile = e.target.files[0] || null;
      this.clientsResult = null;
    },
    async uploadClients() {
      if (!this.clientsFile) return;
      this.clientsLoading = true;
      this.clientsResult = null;
      try {
        const fd = new FormData();
        fd.append("file_name", this.clientsFile);
        fd.append("sklad_id", localStorage.getItem("sklad_id") || 1);
        const res = await axios.post("api/v1/upload/clients-xlsx", fd);
        this.clientsResult = res.data;
        this.page = 1;
        this.loadBalances(false);
      } catch (e) {
        alert("Xato: " + (e.response?.data?.message || e.message));
      } finally {
        this.clientsLoading = false;
      }
    },
    Data() {
      // Eski metod nomi — yangidan yuklash
      this.page = 1;
      this.loadBalances(false);
    },
    Selectkontragent(item) {
      this.$router.push({ path: '/malumot/kontragent/update/' + item.id });
    },
    Trash(id) {
      if (!confirm("Haqiqatan ham bu mijozni o'chirmoqchimisiz?")) return;
      axios.delete("api/v1/kontragent/id/" + id).then(() => {
        this.Data();
      }).catch(err => {
        console.error("O'chirishda xato:", err);
        alert("O'chirishda xatolik yuz berdi");
      });
    },

    async loadKassaBalance() {
      try {
        const res = await axios.get('api/v1/kontragent/kassa-balance');
        this.kassaBalance = res.data || null;
      } catch (e) { /* ignore */ }
    },
    async loadDollarRate() {
      try {
        const res = await axios.get('api/v1/dollar-exchange-rate/last');
        const r = Number((res.data && res.data.rate) || 0);
        if (r > 1) this.currentRate = r;
      } catch (e) { /* ignore */ }
    },

    /* ─── To'lov modal ─── */
    openPayModal(item) {
      this.payTarget = item;
      const sumDefault = (this.payTypes.find(p => p.id !== this.dollarPayTypeId) || { id: 1 }).id;
      let defaultType = sumDefault;
      if ((item.balance || 0) <= 0 && (item.balance_dollar || 0) > 0) {
        defaultType = this.dollarPayTypeId;
      }
      this.payForm = {
        pay_type_id: defaultType,
        summa: 0,
        comment: '',
        convert_to_sum: false,
        convert_to_dollar: false,
        add_debt_only: false,
        debt_mode: 'kassasiz',
        qarz_summa: 0,
        qarz_comment: '',
      };
      this.loadKassaBalance();
      this.$bvModal.show('modal-pay');
    },

    async submitPay() {
      // Hech bo'lmaganda summa yoki qarz qiymati berilishi kerak
      const summa = Number(this.payForm.summa || 0);
      const qarzVal = this.payForm.add_debt_only ? Number(this.payForm.qarz_summa || 0) : 0;
      // Qarz turi: 'kassadan' — kassadan pul berib qarz | 'kassasiz' — oddiy/eski qarz
      const isKassaDebt   = this.payForm.debt_mode === 'kassadan';
      const qarzSumma      = isKassaDebt ? 0 : qarzVal;   // kassasiz qarz
      const qarzKassaSumma = isKassaDebt ? qarzVal : 0;   // kassadan berilgan qarz
      if (!this.payTarget || (summa <= 0 && qarzVal <= 0)) {
        alert("Summa yoki qarz qiymati kiriting");
        return;
      }

      const isDollar = this.payForm.pay_type_id === this.dollarPayTypeId;
      const ccy = isDollar ? '$' : "so'm";
      let confirmText = '';
      if (summa > 0) {
        confirmText += `${summa.toLocaleString('ru-RU')} ${ccy} to'lov`;
        if (this.payForm.convert_to_sum && isDollar) confirmText += ' (KONVERT $→so\'m qarzga)';
        if (this.payForm.convert_to_dollar && !isDollar) confirmText += ' (KONVERT so\'m→$ qarzga)';
        confirmText += '\n';
      }
      if (qarzKassaSumma > 0) {
        confirmText += `+${qarzKassaSumma.toLocaleString('ru-RU')} ${ccy} qarz — KASSADAN pul berib (kassadan chiqim)\n`;
      } else if (qarzSumma > 0) {
        confirmText += `+${qarzSumma.toLocaleString('ru-RU')} ${ccy} qarz qo'shiladi (kassa ta'sirsiz)\n`;
      }
      confirmText += `\nMijoz: ${this.payTarget.name}`;
      if (!confirm(confirmText)) return;

      this.paying = true;
      try {
        await axios.post('api/v1/kontragent-pay', {
          datetime: Math.floor(Date.now() / 1000),
          sklad_id: parseInt(localStorage.getItem('sklad_id')) || 1,
          kontragent_id: this.payTarget.id,
          summa: summa,
          pay_type_id: this.payForm.pay_type_id,
          comment: this.payForm.comment || '',
          current_total: 0,
          dollar_rate: this.currentRate,
          // Konvertatsiya flaglari (ikki tomonlama):
          convert_to_sum:    !!this.payForm.convert_to_sum,    // $ → so'm
          convert_to_dollar: !!this.payForm.convert_to_dollar, // so'm → $
          // Qarz qo'shish — kassasiz (oddiy/eski qarz)
          qarz_summa: qarzSumma,
          // Qarz qo'shish — kassadan pul berib (kassadan chiqim + qarz oshadi)
          qarz_kassa_summa: qarzKassaSumma,
          qarz_comment: this.payForm.qarz_comment || '',
        });
        this.$bvModal.hide('modal-pay');
        this.payTarget = null;
        await this.loadBalances(false);
        await this.loadKassaBalance();
        alert("✅ Saqlandi");
      } catch (e) {
        console.error(e);
        alert("Xatolik: " + (e.response?.data?.message || e.message));
      } finally {
        this.paying = false;
      }
    },
  }
};
</script>

<style scoped>
/* SAHIFA ASOSI */
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-container {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* HEADER */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 26px;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* SEARCH INPUT */
.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
}

.modern-search {
  background: white;
  border: 1px solid #e2e8f0;
  padding: 8px 15px 8px 35px;
  border-radius: 12px;
  width: 250px;
  outline: none;
  transition: 0.3s;
}

.modern-search:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.1);
}

/* TUGMALAR */
.add-btn {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border: none;
  height: 40px;
  padding: 0 20px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(161, 66, 244, 0.3);
}

.refresh-btn {
  background: white;
  border: 1px solid #e2e8f0;
  color: #64748b;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  cursor: pointer;
}

/* JADVAL KARTASI */
.table-card {
  background: white;
  border-radius: 24px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-wrapper {
  overflow-y: auto;
  flex-grow: 1;
}

.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 5;
  padding: 18px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f5f9;
}

.custom-table td {
  padding: 15px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 14px;
  color: #334155;
}

/* Folder ko'rinishi */
.folder-row {
  background-color: #fffbeb;
  cursor: pointer;
}

.folder-row:hover {
  background-color: #fef3c7;
}

.navigation-row {
  cursor: pointer;
}

.navigation-row:hover td {
  color: #a142f4;
}

/* ID & Status badges */
.id-badge {
  background: #f1f5f9;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}

.status-badge {
  background: #f0fdf4;
  color: #16a34a;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  border: 1px solid #dcfce7;
}

.font-bold {
  font-weight: 700;
}

/* AMALLAR */
.actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  cursor: pointer;
}

.edit {
  background: #eff6ff;
  color: #2563eb;
}

.edit:hover {
  background: #2563eb;
  color: white;
  transform: scale(1.1);
}

.del {
  background: #fff1f2;
  color: #e11d48;
}

.del:hover {
  background: #e11d48;
  color: white;
  transform: scale(1.1);
}

.table-footer {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f1f5f9;
  color: #64748b;
  font-size: 13px;
}

.empty-row {
  text-align: center;
  padding: 60px;
  color: #94a3b8;
  font-style: italic;
}

/* SALE TYPE FILTER */
.sale-type-filter {
  display: flex;
  gap: 4px;
  background: #f1f5f9;
  border-radius: 12px;
  padding: 4px;
}

.filter-btn {
  padding: 6px 14px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: #64748b;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: 0.2s;
}

.filter-btn.active {
  background: #a142f4;
  color: white;
  box-shadow: 0 2px 8px rgba(161, 66, 244, 0.25);
}

/* SALE TYPE BADGE */
.sale-type-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
}

.sale-type-badge.chakana {
  background: #eff6ff;
  color: #2563eb;
  border: 1px solid #dbeafe;
}

.sale-type-badge.optom {
  background: #fef3c7;
  color: #d97706;
  border: 1px solid #fde68a;
}

/* ─── BALANCE FILTER ROW ─── */
.balance-filter-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  background: white;
  border-radius: 14px;
  padding: 12px 16px;
  margin-bottom: 14px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
}

.bf-btn {
  background: #f1f5f9;
  border: 2px solid transparent;
  color: #64748b;
  padding: 7px 16px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  transition: 0.2s;
}

.bf-btn:hover { background: #e2e8f0; }

.bf-btn.active {
  background: #faf5ff;
  border-color: #a142f4;
  color: #a142f4;
  box-shadow: 0 2px 8px rgba(161,66,244,0.12);
}

.balance-summary {
  display: flex;
  gap: 18px;
  margin-left: auto;
  align-items: center;
  flex-wrap: wrap;
}

.bs-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.bs-label {
  font-size: 10px;
  color: #94a3b8;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.bs-cell strong {
  font-size: 15px;
  font-weight: 800;
  font-family: 'Inter', system-ui, sans-serif;
}

.bs-positive { color: #dc2626; }
.bs-negative { color: #16a34a; }

/* ─── TABLE NUM CELL ─── */
.custom-table th.num,
.custom-table td.num { text-align: right; }

/* ─── BALANS BADGE ─── */
.bal-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 800;
  font-family: 'Inter', system-ui, sans-serif;
  white-space: nowrap;
}

.bal-debt {
  background: #fee2e2;
  color: #b91c1c;
}

.bal-credit {
  background: #dcfce7;
  color: #15803d;
}

.text-muted { color: #94a3b8; }

/* ─── STATUS PILL ─── */
.status-pill {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.sb-debt   { background: #fee2e2; color: #b91c1c; }
.sb-credit { background: #dcfce7; color: #15803d; }
.sb-zero   { background: #f1f5f9; color: #64748b; }

/* ─── ICON BUTTON: PAY ─── */
.icon-btn.pay {
  background: #dcfce7;
  color: #15803d;
}
.icon-btn.pay:hover {
  background: #16a34a;
  color: white;
  transform: scale(1.05);
}

/* ─── LOAD MORE ─── */
.btn-load-more {
  background: #faf5ff;
  border: 1px solid #e9d5ff;
  color: #a142f4;
  padding: 7px 16px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
}
.btn-load-more:hover { background: #f3e8ff; }

/* ─── SPINNER ─── */
.spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid #e9d5ff;
  border-top-color: #a142f4;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  vertical-align: middle;
  margin-right: 8px;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* ─── PAY MODAL ─── */
.pay-content { padding: 5px; }

.pay-balance-row {
  display: flex;
  gap: 14px;
  background: #f8fafc;
  padding: 12px 16px;
  border-radius: 12px;
  margin-bottom: 16px;
}

.pb-cell {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.pb-label {
  font-size: 10px;
  color: #94a3b8;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.pb-cell strong {
  font-size: 18px;
  font-weight: 800;
  font-family: 'Inter', system-ui, sans-serif;
  margin-top: 4px;
}

.positive { color: #dc2626; }
.negative { color: #16a34a; }

/* PayType radio grid */
.paytype-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.pt-option {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 14px;
  cursor: pointer;
  font-weight: 700;
  font-size: 14px;
  color: #334155;
  transition: 0.2s;
  margin: 0;
}

.pt-option input[type="radio"] { display: none; }

.pt-option:hover { border-color: #cbd5e1; }

.pt-option.active {
  border-color: #a142f4;
  background: #faf5ff;
  color: #7c3aed;
  box-shadow: 0 2px 8px rgba(161,66,244,0.12);
}

.pt-option.dollar-opt.active {
  border-color: #16a34a;
  background: #f0fdf4;
  color: #15803d;
  box-shadow: 0 2px 8px rgba(22,163,74,0.12);
}

.pt-option small {
  font-size: 11px;
  font-weight: 600;
  opacity: 0.7;
}

/* form */
.form-unit {
  margin-bottom: 14px;
}

.form-unit label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  margin-bottom: 7px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-input {
  width: 100%;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 14px;
  color: #1e293b;
  font-weight: 600;
  font-size: 14px;
  outline: none;
  transition: 0.2s;
}

.form-input:focus {
  background: white;
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161,66,244,0.08);
}

.hint {
  font-size: 11px;
  font-weight: 600;
  margin-top: 5px;
  padding: 6px 10px;
  border-radius: 8px;
  background: #f8fafc;
  color: #64748b;
}
.hint.warn { background: #fef3c7; color: #92400e; }

/* KASSA BALANSI */
.kassa-row {
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  border: 1px solid #6ee7b7;
  border-radius: 10px;
  padding: 10px 14px;
  margin-bottom: 14px;
}
.kr-title {
  font-size: 11px;
  font-weight: 800;
  color: #065f46;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}
.kr-cells {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
}
.kr-cell {
  display: flex;
  flex-direction: column;
}
.kr-cell.dollar strong { color: #15803d; }
.kr-label {
  font-size: 10px;
  color: #6b7280;
  font-weight: 700;
  text-transform: uppercase;
}
.kr-cell strong {
  font-size: 16px;
  font-weight: 800;
  color: #065f46;
  font-family: 'Inter', system-ui;
}

/* KONVERTATSIYA */
.convert-block {
  background: linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%);
  border: 1px solid #c4b5fd;
  border-radius: 10px;
  padding: 10px 14px;
  margin: -8px 0 8px 0;
}
.conv-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13px;
  color: #5b21b6;
  margin: 0;
}
.conv-toggle input { width: 18px; height: 18px; cursor: pointer; }
.conv-text strong { color: #4c1d95; }
.conv-info {
  background: white;
  border-radius: 8px;
  padding: 8px 12px;
  margin-top: 8px;
  font-size: 12px;
  color: #475569;
  line-height: 1.6;
}
.conv-info b { color: #1e293b; font-family: 'Inter', system-ui; }
.conv-info .positive { color: #16a34a; }
.conv-cassa {
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px dashed #cbd5e1;
  color: #15803d;
  font-weight: 600;
}

/* QARZ QO'SHISH */
.add-debt-block {
  margin-top: 14px;
  padding: 12px;
  background: #fff7ed;
  border: 1.5px dashed #fed7aa;
  border-radius: 10px;
}
.ad-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13px;
  color: #92400e;
  margin: 0;
}
.ad-toggle input { width: 18px; height: 18px; cursor: pointer; }
.ad-toggle strong { color: #78350f; }
.ad-fields { margin-top: 10px; }

/* Qarz turi tanlash (kassasiz / kassadan) */
.debt-mode { display: flex; gap: 8px; margin-bottom: 10px; }
.dm-opt {
  flex: 1;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  background: #fff;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px 10px;
  cursor: pointer;
  transition: 0.15s;
  margin: 0;
}
.dm-opt input { margin-top: 2px; cursor: pointer; }
.dm-opt span { display: flex; flex-direction: column; font-size: 13px; font-weight: 700; color: #334155; }
.dm-opt span small { font-weight: 500; font-size: 11px; color: #94a3b8; }
.dm-opt.active { border-color: #f59e0b; background: #fffbeb; }
.dm-opt.active span { color: #92400e; }

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 14px;
  border-top: 1px solid #f1f5f9;
}

.btn-cancel {
  background: #f1f5f9;
  color: #64748b;
  border: none;
  padding: 9px 20px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
}

.btn-save {
  background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
  color: white;
  border: none;
  padding: 9px 22px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 4px 12px rgba(22,163,74,0.25);
}

.btn-save:disabled {
  background: #cbd5e1;
  box-shadow: none;
  cursor: not-allowed;
}

.font-bold { font-weight: 700; color: #1e293b; }
</style>